export default "__VITE_ASSET__820da057__"